import { SvgIcon, SvgIconProps } from '@mui/material';

const PdfCvupIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M10.7781 1.73178C10.5984 1.58202 10.3719 1.5 10.138 1.5H4.5C3.675 1.5 3 2.175 3 3V15C3 15.825 3.6675 16.5 4.4925 16.5H13.5C14.325 16.5 15 15.825 15 15V5.71837C15 5.42159 14.8682 5.14015 14.6402 4.95015L10.7781 1.73178ZM14.25 14.75C14.25 15.3023 13.802 15.75 13.2497 15.75C10.2426 15.75 7.71708 15.75 4.75018 15.75C4.19789 15.75 3.75 15.3023 3.75 14.75V9C3.75 6.7163 3.75 5.30182 3.75 3.25049C3.75 2.69821 4.19772 2.25 4.75 2.25H9.5C10.0523 2.25 10.5 2.69772 10.5 3.25V4.25C10.5 4.80228 10.9477 5.25 11.5 5.25H13.25C13.8023 5.25 14.25 5.69771 14.25 6.25V14.75Z"
      fill="#212121"
    />
    <path d="M14.7614 5.4H10.4414V1.8L14.7614 5.4Z" fill="#212121" />
    <path
      d="M5.62129 11.196C5.38129 11.196 5.17129 11.1432 4.99129 11.0376C4.81129 10.932 4.67209 10.782 4.57369 10.5876C4.47769 10.3908 4.42969 10.1616 4.42969 9.9C4.42969 9.6384 4.47769 9.4104 4.57369 9.216C4.67209 9.0192 4.81129 8.868 4.99129 8.7624C5.17129 8.6568 5.38129 8.604 5.62129 8.604C5.83249 8.604 6.01489 8.6448 6.16849 8.7264C6.32209 8.8056 6.43489 8.9184 6.50689 9.0648L6.17569 9.3492C6.05089 9.1596 5.86849 9.0648 5.62849 9.0648C5.42449 9.0648 5.26969 9.1356 5.16409 9.2772C5.06089 9.4164 5.00929 9.624 5.00929 9.9C5.00929 10.1736 5.06089 10.3812 5.16409 10.5228C5.26729 10.6644 5.41849 10.7352 5.61769 10.7352C5.86969 10.7352 6.05569 10.6404 6.17569 10.4508L6.50689 10.7352C6.43489 10.8816 6.32209 10.9956 6.16849 11.0772C6.01489 11.1564 5.83249 11.196 5.62129 11.196Z"
      fill="black"
    />
    <path
      d="M8.92558 8.64L8.04358 11.16H7.52518L6.64318 8.64H7.24798L7.78438 10.422L8.32078 8.64H8.92558Z"
      fill="black"
    />
    <path
      d="M10.1716 11.196C9.84277 11.196 9.59317 11.1108 9.42277 10.9404C9.25477 10.7676 9.17077 10.5144 9.17077 10.1808V8.64H9.75037V10.1736C9.75037 10.3584 9.78517 10.4988 9.85477 10.5948C9.92677 10.6884 10.0324 10.7352 10.1716 10.7352C10.3108 10.7352 10.4152 10.6884 10.4848 10.5948C10.5568 10.4988 10.5928 10.3584 10.5928 10.1736V8.64H11.1724V10.1808C11.1724 10.5144 11.0872 10.7676 10.9168 10.9404C10.7488 11.1108 10.5004 11.196 10.1716 11.196Z"
      fill="black"
    />
    <path
      d="M11.5974 8.64H12.4686C12.771 8.64 13.0002 8.7096 13.1562 8.8488C13.3146 8.9856 13.3938 9.1884 13.3938 9.4572C13.3938 9.7404 13.3134 9.9552 13.1526 10.1016C12.9942 10.248 12.7602 10.3212 12.4506 10.3212H12.177V11.16H11.5974V8.64ZM12.4902 9.864C12.6006 9.864 12.6846 9.8304 12.7422 9.7632C12.7998 9.696 12.8286 9.5988 12.8286 9.4716C12.8286 9.3492 12.7974 9.2568 12.735 9.1944C12.675 9.132 12.585 9.1008 12.465 9.1008H12.177V9.864H12.4902Z"
      fill="black"
    />
  </SvgIcon>
);
export default PdfCvupIcon;
